import React from "react"
import {Button} from "react-bootstrap"
import Modal from "react-bootstrap/Modal"

const TradeInAcceptanceModal = ({showModal, onConfirm, onCancel}) => {
  return (
    <Modal show={showModal} backdrop="static" keyboard={false} className="modal-info" centered onHide={onCancel}>
      <Modal.Header closeButton>
        <h1 className="w-100 text-center">Noleggio Smart Trade-In</h1>
      </Modal.Header>

      <hr/>

      <Modal.Body className="text-center">
        <h2>
          Approfitta di un canone di noleggio più leggero grazie alla nostra offerta Smart Trade-In: un modo semplice e
          intelligente per valorizzare il tuo dispositivo usato.
        </h2>
      </Modal.Body>

      <Modal.Footer className="flex-column border-0 pt-0">
        <Button
          variant="primary"
          onClick={onConfirm}
          className="w-100 mb-2"
          style={{fontWeight: "600", fontSize: "1.1rem"}}
        >
          Sì, grazie
        </Button>
        <Button
          variant="outline-secondary"
          onClick={onCancel}
          className="w-100"
          style={{fontWeight: "600", fontSize: "1.1rem"}}
        >
          No, grazie
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TradeInAcceptanceModal
